import { css, cva } from '@/styled-system/css';

export const spinnerStyles = cva({
  // TODO: use animation tokens when available
  base: {
    animation: 'spin 0.5s linear infinite',
    stroke: 'currentColor',
  },
  variants: {
    onImpact: {
      false: {
        color: 'ProgressIndicator.spinner.icon.default',
      },
      true: {
        color: 'ProgressIndicator.spinner.icon.onImpact',
      },
    },
  },
});

export const spinnerFillStyle = css.raw({
  width: '100%',
  height: '100%',
  backgroundImage: 'conic-gradient(from 90deg at 50% 66%, transparent 20deg, currentColor 360deg)',
});
